import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-time",
  "use": "icon-time-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"icon-time\"><path class=\"st0\" d=\"M100 6.1C49.4 6.1 8.3 47.2 8.3 97.8s41.1 91.7 91.7 91.7 91.7-41.1 91.7-91.7S150.6 6.1 100 6.1zm54.3 123.4c-2.2 3.8-7.1 5.1-10.9 2.9l-47.2-27.3c-1.8-1-3-2.7-3.6-4.5-.3-.9-.5-1.8-.5-2.8V64.1c0-4.4 3.6-8 8-8s8 3.6 8 8v29.5l43.3 25c3.8 2.2 5.1 7.1 2.9 10.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol